import React from 'react';
import Step1 from './pages/Step1.js';
import Step2 from './pages/Step2.js';
import Step3 from './pages/Step3.js';
import Step4 from './pages/Step4.js';
import Confirmation from './pages/Confirmation.js';
import LookupRez from './pages/LookupRez.js';

import VehicleClass from './models/VehicleClass.js';
//import PersonalInfo from './models/PersonalInfo.js';

import Location from './models/Location.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

export default class App extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      confirmationDetails : {},

      pickupLocation : new Location(),
      dropoffLocation : new Location(),
      vehicleClass : new VehicleClass(),
      extraOptions : [],
      personalInfo : '',
      discountCode : '',
      confirmationNum : '',
      age : 0,
      //upgradeList : [],
      currentStep : 1,
      isModify : false
    };

    this.setAddRezConfirmationDetails = this.setAddRezConfirmationDetails.bind(this);
    this.setLocationDetails = this.setLocationDetails.bind(this);
    this.setVehicleClass = this.setVehicleClass.bind(this);
    this.setUpgradeClass = this.setUpgradeClass.bind(this);
    this.setExtraOptions = this.setExtraOptions.bind(this);
    this.setPersonalInfo = this.setPersonalInfo.bind(this);
    //this.setUpgradeList = this.setUpgradeList.bind(this);
    this.returnToStep = this.returnToStep.bind(this);
    this.modifyRez = this.modifyRez.bind(this);
    this.loadReservationDetails = this.loadReservationDetails.bind(this);
  }

  componentDidMount(){
    //testing
    /*var pl = new Location();
    pl.locationId = 'NIS';
    pl.locationCity = "SAVANNAH";
    pl.date = new Date(Date.parse('2022-02-11 00:00:00'));
    pl.time = '09:30 AM';
    var dl = new Location();
    dl.locationId = 'NIS';
    dl.locationCity = "SAVANNAH";
    dl.date = new Date(Date.parse('2022-02-12 00:00:00'));
    dl.time = '09:30 AM';
    var vc = new VehicleClass();
    vc.setClass('CCAR');
    vc.setRateId('397955804');
    vc.setModelDesc('Nissan Versa or Similar');
    vc.setModelDesc('Nissan Versa or Similar');
    var pi = new PersonalInfo();
    pi.dob = new Date(Date.parse('1988-01-01 00:00:00'));
    pi.firstName = 'John';
    pi.lastName = 'Smith';
    pi.phone = '111-111-1111';
    pi.email = 'bobby.yawn@danvaden.com';
    pi.agreedTerms = true;

  var confirmationDetails = {
      totalPricing : {
        totalCharges : 33.33
      },
      confirmMessage : "Thank You",
      confirmNum : "WSC0006E68",
      confirmedRate : "This is a fake confirmed rate",
      classImgURL : "carimages/ccar.jpg",

      renterFirst : pi.firstName,
      renterLast : pi.lastName,
      renterCellPhone : pi.phone,
      emailAddress : pi.email,
      rentalLocationID : pl.locationId,
      pickupDateTime : '02082022 12:00 AM',
      returnLocationID : dl.locationId,
      returnDateTime : '02082022 12:00 AM',
      modelDesc : vc.modelDesc,
      dailyExtras : [{
        autoApplied : 'FALSE',
        extraCode : 'CODE',
        extraDesc : 'THIS IS AN EXTRA'
      }]
    };
    this.setState({
        currentStep : 4,
        pickupLocation : pl,
        dropoffLocation : dl,
        vehicleClass : vc,
        extraOptions : [],//'SLI', '002', '002', 'UA01'],
        extraOptions : [],
        personalInfo : pi,
        discountCode : 'MIL01',
        age : 25,
        confirmationDetails : confirmationDetails
    });*/

    //this.loadReservationDetails(pl, dl, '', vc, ['SLI'], pi);
  }

  // load reservation data for editing details
  loadReservationDetails(confirmationNum, pickup, dropoff, discountCode, vehicleClass, extras, personalInfo){
    this.setState({
        confirmationNum : confirmationNum,
        pickupLocation : pickup,
        dropoffLocation : dropoff,
        discountCode : discountCode,
        vehicleClass : vehicleClass,
        extraOptions : extras,
        personalInfo : personalInfo,
        isModify : true
    });
  }

  setLocationDetails(pickup, dropoff, discountCode, age, extras){ // step 1
    //console.log('App setItDetails')
    var extraOptions = extras;

    if(parseInt(age) < 25)
      extraOptions.push('UA01');  // add underage fee

    this.setState(function(state, props){
      return {
        pickupLocation : pickup,
        dropoffLocation : dropoff,
        discountCode : discountCode,
        age : age,
        extraOptions : extraOptions,
        currentStep : 2
      };
    });
    //console.log(age);
    //console.log(extraOptions);
    // activate step 2
  }

  setVehicleClass(vehicleClass){
    //console.log(vehicle_class)
    this.setState(function(state, props){
      return {
        vehicleClass : vehicleClass,
        currentStep : 3
      };
    });
  }

  setExtraOptions(options){
    //console.log('EXTRAS SELECTED')
    //console.log(options)
    this.setState(function(state, props){
      return {
        extraOptions : options,
        currentStep : 4
      };
    });
  }

  setPersonalInfo(info){
    this.setState({
        personalInfo : info//,
        //currentStep : 5
    });
  }

  setAddRezConfirmationDetails(confirmationDetails){
    this.setState({
      confirmationDetails : confirmationDetails,
      currentStep : 5
    });
  }

  /*setUpgradeList(list){
    this.setState({upgradeList : list}, () => { console.log(this.state.upgradeList)});
  }*/

  // use to return to previous steps
  returnToStep(step){
    //console.log(this.state)
    this.setState(function(state, props){
      return{
        currentStep : step
      }
    });
  }

  modifyRez(){
    this.setState(function(state, props){
      return{
        currentStep : 'modify'
      }
    });
  }

  setUpgradeClass(vehicleClass){
    this.setState({
        vehicleClass : vehicleClass
    });
  }

  render(){
        if (this.state.currentStep === 1) {
          return (
            <div className="App">
              <Step1 pickup={this.state.pickupLocation} dropoff={this.state.dropoffLocation} discountCode={this.state.discountCode} extras={this.state.extraOptions} setLocationDetails={this.setLocationDetails} getLocationDetails={this.getLocationDetails} currentStep={this.state.currentStep} modifyRez={this.modifyRez} age={this.state.age} />
            </div>
          );
        }else if(this.state.currentStep === 2){
          return (
            <div className="App">
              <Step2 isModifyRez={this.state.isModify} pickup={this.state.pickupLocation} dropoff={this.state.dropoffLocation} discountCode={this.state.discountCode} vehicleClass={this.state.vehicleClass} extras={this.state.extraOptions} personalInfo={this.state.personalInfo} setVehicleClass={this.setVehicleClass} returnToStep={this.returnToStep} currentStep={this.state.currentStep} />
            </div>
          );
        }else if(this.state.currentStep === 3){
          //console.log('App extras = ')
          //console.log(this.state.extraOptions)
          return (
            <div className="App">
              <Step3 isModifyRez={this.state.isModify} pickup={this.state.pickupLocation} dropoff={this.state.dropoffLocation} discountCode={this.state.discountCode} vehicleClass={this.state.vehicleClass} extras={this.state.extraOptions} personalInfo={this.state.personalInfo} setExtraOptions={this.setExtraOptions} returnToStep={this.returnToStep} currentStep={this.state.currentStep}
              setUpgradeClass={this.setUpgradeClass}/>
            </div>
          );
        }else if(this.state.currentStep === 4){
          return (
            <div className="App">
              <Step4 confirmationNum={this.state.confirmationNum} isModifyRez={this.state.isModify} pickup={this.state.pickupLocation} dropoff={this.state.dropoffLocation} discountCode={this.state.discountCode} vehicleClass={this.state.vehicleClass} returnToStep={this.returnToStep} currentStep={this.state.currentStep} personalInfo={this.state.personalInfo} extras={this.state.extraOptions} setPersonalInfo={this.setPersonalInfo} setConfirmationDetails={this.setAddRezConfirmationDetails} setUpgradeClass={this.setUpgradeClass} />
            </div>
          );
        }
        else if(this.state.currentStep === 5){
          return (
            <div className="App">
              <Confirmation isModifyRez={this.state.isModify} pickup={this.state.pickupLocation} dropoff={this.state.dropoffLocation} vehicleClass={this.state.vehicleClass} discountCode={this.state.discountCode} returnToStep={this.returnToStep} personalInfo={this.state.personalInfo} extras={this.state.extraOptions} confirmationDetails={this.state.confirmationDetails} />
            </div>
          );
        }else if(this.state.currentStep === 'modify'){
          return (
            <div className="App">
              <LookupRez loadDetails={this.loadReservationDetails} returnToStep={this.returnToStep} />
            </div>
          );
        }else{
          return(<div>Loading Site</div>);
        }

  }
}
